import { ServiceDefinition } from '~/constants/services/types';
import { BufferEditorOptions } from '~/editor/BufferEditor/types';
import { createNewEditor } from '../../editor';
import { Draft } from './Draft';

export const getNewDraft = (
  service: ServiceDefinition,
  options?: BufferEditorOptions
) => {
  const editor = createNewEditor(service, options);
  return new Draft(service, editor);
};
